<template>	   
	<div>
		<material-card
          color="warning"
          title="Error: 404"
          text="Pagina no encontrada"
        >
         <v-layout justify-center align-center>
           <v-flex xs12 class="text-md-center">
           	<h1><v-icon color="warning">fas fa-exclamation-triangle</v-icon>	</h1>
             <h3 class="text-md-center">Lo sentimos la pagina a la que trata de acceder no existe confirme la ruta o pongase en contacto con el administrador</h3>
             <v-divider></v-divider>
             <v-btn color="success">Regresar</v-btn>
           </v-flex>
         </v-layout>
        </material-card>
	</div>
</template>
<script>
	export default{
		created() {

		},
		mounted(){

		},
		props: [
			
		],
		data(){
			return {
				 data: '',
			}
		},
		methods: {

		},
		watch: {

		},
		computed: {

		},
	}
</script>